
import {Vue, Component, Prop} from 'vue-property-decorator';

@Component({})
export default class VacancyCard extends Vue {
  @Prop({ required: true }) readonly title!: string;
  @Prop({ required: true }) readonly description!: string;
  @Prop() readonly hours?: string;
  @Prop() readonly role?: string;
  @Prop() readonly location?: string;
  @Prop({ required: true }) readonly link!: string;
  @Prop({ required: true }) readonly image!: string;
}
